/* Bandeau "code personnel" du flycart.
   Charge inconditionnellement depuis cart-drawer.liquid : les scripts inseres
   par un morph de Section Rendering ne s'executent JAMAIS - ce fichier doit
   donc vivre hors de la zone morphee (meme raison que cart-routine.js). */
(function () {
  if (window.__wcfInstalle) return;
  window.__wcfInstalle = true;

  var CODE = 'wills:code', EXP = 'wills:code:expire';
  function lire(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }

  function texteRestant(ms) {
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
  }

  function codeDejaAuPanier(c) {
    return !!document.querySelector('.cart-discount__pill[data-discount-code="' + (window.CSS && CSS.escape ? CSS.escape(c) : c) + '"]');
  }

  /* Le seul critere de masquage durable est l'etat REEL du panier (pastille
     presente). Pas de verrou persistant : un panier neuf sans le code doit
     re-proposer le bandeau, meme si le code a deja ete applique un jour. */
  function initialiser(racine) {
    var code = (lire(CODE) || '').trim();
    if (!code) return;
    var expire = lire(EXP);
    if (expire) {
      var t = Date.parse(expire);
      if (!isNaN(t) && t < Date.now()) return;
    }
    if (codeDejaAuPanier(code)) { racine.hidden = true; return; }
    if (racine.dataset.wcfPret === '1') return;
    racine.dataset.wcfPret = '1';

    racine.hidden = false;
    racine.querySelector('[data-wcf-code]').textContent = code;
    var elExp = racine.querySelector('[data-wcf-expire]');
    if (expire) {
      elExp.hidden = false;
      var elVal = racine.querySelector('[data-wcf-expire-val]');
      var tic = function () {
        if (!document.contains(elVal)) return;
        var reste = Date.parse(expire) - Date.now();
        elVal.textContent = reste <= 0 ? 'Expired' : texteRestant(reste);
        if (reste > 0) setTimeout(tic, 1000);
      };
      tic();
    }
  }

  function balayer() { document.querySelectorAll('[data-wcf]').forEach(initialiser); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wcf-apply]');
    if (!btn) return;
    var racine = btn.closest('[data-wcf]');
    var code = racine.querySelector('[data-wcf-code]').textContent;

    var champ = document.querySelector('cart-discount-component input[name="discount"]');
    var form = champ && champ.closest('form');
    if (!champ || !form) return;
    btn.disabled = true; btn.textContent = '…';
    champ.value = code;
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    var essais = 0;
    var attendre = setInterval(function () {
      essais++;
      if (codeDejaAuPanier(code)) {
        clearInterval(attendre);
        racine.hidden = true;
      } else if (essais >= 10) {
        clearInterval(attendre);
        btn.disabled = false; btn.textContent = 'Apply';
      }
    }, 600);
  });

  var MINIMUM_CENTS = 3900;
  async function preciserErreurMinimum() {
    var err = document.querySelector('.cart-discount__error:not(.hidden) [ref="cartDiscountErrorDiscountCode"]:not(.hidden)');
    if (!err || err.dataset.wcfMin === '1') return;
    err.dataset.wcfMin = '1';
    try {
      var p = await (await fetch('/cart.js')).json();
      var manque = MINIMUM_CENTS - p.items_subtotal_price;
      if (manque > 0) {
        err.textContent = 'Almost there - add $' + (manque / 100).toFixed(2) +
          ' more to reach the $39 minimum for this code.';
      }
    } catch (e) {}
  }

  var minuteur = null;
  new MutationObserver(function () {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { balayer(); preciserErreurMinimum(); }, 120);
  }).observe(document.body, { childList: true, subtree: true,
    attributes: true, attributeFilter: ['class', 'hidden'] });

  if (document.readyState !== 'loading') balayer();
  else document.addEventListener('DOMContentLoaded', balayer);
})();
